import { useMemo } from 'react'

import { useOpportunityStore } from '@/stores/opportunity-store'

export function useStatistics() {
  const statistics = useOpportunityStore((s) => s.statistics)
  const pipeline = useOpportunityStore((s) => s.pipeline)
  const filters = useOpportunityStore((s) => s.filters)

  const funnelMax = useMemo(() => {
    if (!statistics) return 1
    return Math.max(1, ...statistics.funnel.map((f) => f.count))
  }, [statistics])

  return {
    statistics,
    pipeline,
    filters,
    funnelMax,
    cards: statistics?.cards ?? null,
    conversionRate: statistics?.conversionRate ?? 0,
    averageTicket: statistics?.averageTicket ?? 0,
    averageCycleDays: statistics?.averageCycleDays ?? 0,
    lostValue: statistics?.lostValue ?? 0,
    recoveredValue: statistics?.recoveredValue ?? 0,
    ranking: statistics?.ranking ?? null,
    lossesByReason: statistics?.lossesByReason ?? [],
    funnel: statistics?.funnel ?? [],
  }
}
